import { useLocation, useNavigate } from 'react-router-dom';

export const usePreserveNavigate = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (to: string | number, options?: { replace?: boolean; state?: any }) => {
    // const query = location.search;
    navigate(`${to}`, options);
  };
};
